export default function WhyCallsFail() {
  const problems = [
    {
      icon: 'ri-speed-up-line',
      title: 'Пытаются продавать слишком рано',
      desc: 'Менеджер начинает презентацию продукта до того, как установил контакт и выявил потребность. Клиент чувствует давление и закрывается.',
    },
    {
      icon: 'ri-file-copy-line',
      title: 'Работают по шаблонным скриптам',
      desc: 'Заученные фразы звучат неестественно, клиент сразу понимает, что с ним говорит робот, и теряет интерес к разговору.',
    },
    {
      icon: 'ri-question-mark',
      title: 'Не понимают цель первого контакта',
      desc: 'Цель холодного звонка — не заключить сделку, а открыть диалог и договориться о следующем шаге. Без этого понимания звонки превращаются в пустую трату времени.',
    },
    {
      icon: 'ri-emotion-sad-line',
      title: 'Боятся отказов',
      desc: 'Страх услышать «нет» парализует, менеджер звучит неуверенно, клиент это чувствует и отказывается от продолжения разговора.',
    },
    {
      icon: 'ri-shield-user-line',
      title: 'Начинают оправдываться',
      desc: 'При первом же возражении менеджер переходит в защитную позицию вместо того, чтобы задать уточняющий вопрос и продолжить диалог.',
    },
    {
      icon: 'ri-admin-line',
      title: 'Спорят с секретарями',
      desc: 'Пытаются доказать секретарю важность звонка вместо того, чтобы выстроить доверительные отношения и получить доступ к ЛПР.',
    },
    {
      icon: 'ri-user-unfollow-line',
      title: 'Не умеют заинтересовывать ЛПР',
      desc: 'Не могут сформулировать ценность разговора за первые 30 секунд, и лицо, принимающее решение, просто не видит смысла продолжать.',
    },
  ];

  return (
    <section id="why-fail" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Почему большинство холодных звонков не работают
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Компании обучают менеджеров холодным звонкам, но результаты не меняются. Разберём, какие ошибки превращают звонки в пустую трату времени и как это исправить.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto mb-12">
          {problems.slice(0, 6).map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-6 border border-gray-100 hover:border-red-200 hover:bg-red-50/30 transition-all duration-300">
              <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                <i className={`${item.icon} text-xl text-red-500`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="grid sm:grid-cols-2 gap-5 max-w-4xl mx-auto">
          {problems.slice(6).map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-6 border border-gray-100 hover:border-red-200 hover:bg-red-50/30 transition-all duration-300">
              <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                <i className={`${item.icon} text-xl text-red-500`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="max-w-4xl mx-auto mt-12">
          <div className="bg-teal-600 rounded-2xl p-8 md:p-12 text-white text-center">
            <div className="w-16 h-16 bg-white/15 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <i className="ri-lightbulb-flash-line text-3xl text-white"></i>
            </div>
            <p className="text-xl md:text-2xl font-bold leading-relaxed">
              Цель холодного звонка — не продать, а открыть возможность для следующего шага.
            </p>
            <p className="text-white/80 mt-4 text-base">
              Когда менеджер это понимает, страх исчезает, а конверсия растёт.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}